import { debugLog } from "@/utils/debug";

let skipProfileFetchOnSignIn = false;

export function setSkipProfileFetchOnSignIn(skip: boolean) {
  skipProfileFetchOnSignIn = skip;
  if (skip) {
    debugLog("Auth", "Profile fetch will be skipped on next SIGNED_IN event");
  }
}

export function shouldSkipProfileFetchOnSignIn() {
  return skipProfileFetchOnSignIn;
}
